import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';
import ExpandCollapseCell from './ExpandCollapseCell';

const DetailHeaderCell = (props: GridHeaderCellProps) => {
  const setExpandedLineItemIds = useContextSelector(
    InvoiceContext,
    (value) => value.setExpandedLineItemIds
  );
  const expandedLineItemIds = useContextSelector(
    InvoiceContext,
    (value) => value.expandedLineItemIds
  );
  const receiptLineItemIds = useContextSelector(
    InvoiceContext,
    (value) => value.receiptLineItemIds
  );
  const isAllExpanded = expandedLineItemIds.length > 0;

  const handleHeaderCellExpand = () => {
    if (expandedLineItemIds.length > 0) {
      setExpandedLineItemIds([]);
    } else {
      setExpandedLineItemIds(receiptLineItemIds);
    }
  };

  return (
    <th
      className="k-header k-hierarchy-cell flex justify-center items-center"
      style={{ borderBottomWidth: '0px' }}
    >
      <ExpandCollapseCell
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};

export default DetailHeaderCell;
